
import { defineComponent, onMounted, PropType, ref, watch } from 'vue';

interface IListBillingUnits {
  code: string;
  name: string;
  fullName: string;
  brands: string[];
  checked: boolean;
}

export default defineComponent({
  components: {},

  props: {
    billingUnitsFilter: {
      type: Object as PropType<IListBillingUnits[]>,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const propsRef = ref(props);
    const selectedValue = ref(props.billingUnitsFilter);

    watch(propsRef.value, (newValue) => {
      selectedValue.value = newValue.billingUnitsFilter;
      emit('filter-tag', selectedValue.value);
      if (newValue.billingUnitsFilter.every((el) => el.checked === true))
        allUnits.value = true;
      else allUnits.value = false;
    });

    onMounted(() => (selectedValue.value = props.billingUnitsFilter));

    onMounted(() => {
      const myDropdown = document.getElementById('dropdown');
      myDropdown?.addEventListener('hide.bs.dropdown', async function () {
        emit('reload-ecomm');
      });
    });

    const changeFilter = (filter) => {
      emit('value-selected', filter);
      emit('filter-tag', selectedValue.value);
      if (selectedValue.value.every((el) => el.checked === true)) {
        allUnits.value = true;
        return;
      }
      allUnits.value = false;
    };

    const allUnits = ref(true);

    const changeAllUnits = () => {
      if (!allUnits.value) {
        selectedValue.value = props.billingUnitsFilter.map((el) => {
          return { ...el, checked: false };
        });
        emit('all-filter', { filterName: 'billingUnit', checked: false });

        return;
      }
      selectedValue.value = props.billingUnitsFilter.map((el) => {
        return { ...el, checked: true };
      });
      emit('filter-tag', selectedValue.value);
      emit('all-filter', { filterName: 'billingUnit', checked: true });
    };

    return { selectedValue, emit, changeFilter, allUnits, changeAllUnits };
  },
});
